/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ unit: NonNullable<unknown> }} Exercise_Sheet_How_TotalInputs */

const en_us2_exercise_sheet_how_total = /** @type {(inputs: Exercise_Sheet_How_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Log the total weight, bar included, in the “${i?.unit}” field.`)
};

const pt_br2_exercise_sheet_how_total = /** @type {(inputs: Exercise_Sheet_How_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registre o peso total, com a barra, no campo “${i?.unit}”.`)
};

const es_419_exercise_sheet_how_total = /** @type {(inputs: Exercise_Sheet_How_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registra el peso total, con la barra incluida, en el campo “${i?.unit}”.`)
};

const pt_pt2_exercise_sheet_how_total = /** @type {(inputs: Exercise_Sheet_How_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Regista o peso total, com a barra, no campo “${i?.unit}”.`)
};

const fr_fr2_exercise_sheet_how_total = /** @type {(inputs: Exercise_Sheet_How_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Note la charge totale, barre comprise, dans le champ « ${i?.unit} ».`)
};

const de_de2_exercise_sheet_how_total = /** @type {(inputs: Exercise_Sheet_How_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trag das Gesamtgewicht inklusive Stange im Feld „${i?.unit}“ ein.`)
};

const it_it2_exercise_sheet_how_total = /** @type {(inputs: Exercise_Sheet_How_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registra il peso totale, bilanciere incluso, nel campo “${i?.unit}”.`)
};

/**
* | output |
* | --- |
* | "Log the total weight, bar included, in the “{unit}” field." |
*
* @param {Exercise_Sheet_How_TotalInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_how_total = /** @type {((inputs: Exercise_Sheet_How_TotalInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_How_TotalInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_how_total(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_how_total(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_how_total(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_how_total(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_how_total(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_how_total(inputs)
	return en_us2_exercise_sheet_how_total(inputs)
});
export { exercise_sheet_how_total as "exercise-sheet.how_total" }